module.exports = __webpack_public_path__ + "img/34.87222c15.webp";